var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('app-header'),_vm._v(" "),_c('app-side-bar'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('transition',{attrs:{"appear":"","enter-class":"","enter-active-class":"animated fadeIn","leave-class":"","leave-active-class":""}},[_c('keep-alive',[_c('router-view')],1)],1)],1),_vm._v(" "),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/views/MainPage.vue